export function parseNoteTime(text) {
  let time
  let match = text.match(/(\(\d+:\d+\d+\))\s*/)

  if (match) {
    text = text.substr(match.index + match[0].length, text.length - 1)
    time = match[1]
  }
  return [text, time]
}

export function noteTimeToNumeric(timeStr) {
  let [m, s] = timeStr.replace(/[\(\)]/g, "").split(":").map(i => parseInt(i))
  return m * 60 + s
}